"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _common = require("../../components/core/common");
var _core = require("../../services/core");
var _media = _interopRequireDefault(require("wever-core/dist/components/common/media"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Core

// Vue
const View = _ref => {
  let {
    media
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column justify-content-center align-items-center w-100 h-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "check-div d-flex justify-content-center align-items-center mb-3"
  }, /*#__PURE__*/_react.default.createElement(_common._Icon, {
    name: "check"
  })), /*#__PURE__*/_react.default.createElement("h2", {
    className: "fw-bold mb-4 mt-1"
  }, (0, _core._translate)('common_w_thanks'), "."), /*#__PURE__*/_react.default.createElement("p", {
    className: "fw-bold mt-1 mb-2"
  }, (0, _core._translate)('registerapp_demand_accepted'), "."), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center"
  }, (0, _core._translate)('registerapp_demand_send')), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-3"
  }, media && /*#__PURE__*/_react.default.createElement(_media.default, {
    data: media,
    className: "ended-img"
  })));
};
var _default = exports.default = View;